class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.accordionType = this.dataset.accordiontype;
    this.filterParent = this.closest('#filtersCollapse');
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.filterForm = this.querySelector('form');
    this.quickshop = document.querySelector('quick-shop');
    this.selectedCollection = undefined;
    const toggleBtns = this.querySelectorAll('.filter__toggle');
    toggleBtns.forEach(button => button.addEventListener('click', this.toggleFilterBlock.bind(this)));
  
    /*********** Open Drawer on Filter or SortBy button click. Close Drawer on close button click *************/
    this.openFilterDrawer = document.getElementById('filter-drawer');
    if(this.openFilterDrawer) this.openFilterDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    this.openSortbyDrawer = document.getElementById('sortby-drawer');
    if(this.openSortbyDrawer) this.openSortbyDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    this.closeFilterDrawer = this.filterParent.querySelector('.collection-filters-close');
    if(this.closeFilterDrawer) this.closeFilterDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    /*********** End of Open Drawer on Filter or SortBy button click. Close Drawer on close button click ********/

    this.sortby_values = document.querySelectorAll('[data-sortby] .sortby_options');
    this.sortby_values.forEach(input => input.addEventListener('change', this.updateSortBy.bind(this)));

    this.subCollectionLinks = document.querySelectorAll('[data-subCollections] .collection-entry');
    this.subCollectionLinks.forEach(link => link.addEventListener('click', this._manageSubCollections.bind(this)));

    let paginateByValues = document.querySelectorAll('[data-custom-pagination] .pagination_value');
    paginateByValues.forEach(input => input.addEventListener('change', this.paginateProductsBy.bind(this)));

    /* Clear Filter */
    // document.querySelector('[data-clearFilter]').addEventListener('click',(e)=>{e.preventDefault(); this.clearFilter(e.currentTarget.href)})

    this.filterParent.addEventListener('keyup', (event) => {
      
      if (event.code.toUpperCase() === 'ESCAPE'){ this.closeFilterDrawer.dispatchEvent(new Event('click')); }
    });

    this.debouncedOnSubmit = Utility.debounce((event) => {
     
      this.onSubmitHandler(event);
    }, 500);

    if(this.filterForm){
      this.filterForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      this.filterForm.addEventListener('submit', this.debouncedOnSubmit.bind(this));
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    const applyBtn = this.querySelector('[data-applyFilters]');
    if(applyBtn){
      applyBtn.addEventListener('click', (event) => {
        // console.log('applied');
        
        this._manageSubCollections(event,true);
      });
    }

    const paginationLinks = document.querySelectorAll('[data-pagination]');
    paginationLinks.forEach(link => link.addEventListener('click', this._managePagination.bind(this)));

    // this.bindActiveFilterButtonEvents();
    this.addAccessibilityAttributes(toggleBtns);
    this.colorOptionsStyling();

/** 
 * Toggle the filter drop down in desktop.
 */
    document.querySelectorAll('.filter__toggle').forEach((i) => i.addEventListener('click', (event)=>{
      
      if (i.classList.contains('open')) {
        const openFilters = document.querySelectorAll('.filter__container.open');
        openFilters.forEach((target) => {
          target.querySelector('.filter__toggle').click();
        })
      }
    }))
  
    this.appliedFiltersToggle();
    this.updateTotalSelected();
  }


  /**
 * 
 * FUNCTIONS OF THIS CLASS START FROM HERE
 */


  /**
   * Filter Block Toggle event
   * @param {NodeList} toggleBtns Open filter block buttons
   */
  addAccessibilityAttributes(toggleBtns) {
    toggleBtns.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  /**
   * Collection filter form Input event
   * @param {event} event Event Instance
   */
  onSubmitHandler(event) {
    event.preventDefault();
    
    // console.log('onSubmitHandler');
    if(window.visualViewport.width <= 991) return;
    let closestForm = document.getElementById('CollectionFiltersForm');
    if(event.target && event.target.closest('form')){ closestForm = event.target.closest('form'); }
    if(!closestForm) return;
    const searchParams = this._finalQueryString(closestForm);
    // console.log('rendering',searchParams);
     this.renderPage(searchParams, event); 
  }

  /**
   * click event To Remove current selections 
   * @param {element} form Collection page filter form
   */
  _finalQueryString(form){
    const formData = new FormData(form);
    console.log('formData----',formData);
    let searchParams = '';
    let constraints = '';
    formData.forEach((val, key) => {
      console.log(key,val);
      if(key.indexOf('price-list') >= 0){
        searchParams += '&' + val;
      }else if(key.indexOf('custom_sort_by') >= 0){
        //  Code for SortBy
      }else if(key.indexOf('tagsFilter-') > -1){
        if(constraints === ''){ constraints = val; }
        else{ constraints += `+${val}`; }
      }else if(val != null && val.length > 0){
        if(searchParams === ''){ searchParams = key + '=' + val;}
        else{ searchParams += '&' + key + '=' + val; }
      }
    });
    if(constraints != ''){
      if(searchParams == ''){
        searchParams = `?constraint=${constraints}`;
      }else{
        searchParams += `&constraint=${constraints}`;
      }
    }
    return searchParams;
  }

  /**
   * Add background color in label of Color options
   */
  colorOptionsStyling(){
    const colorSwatchContainer = this.querySelector('[data-colorFilter]');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.color-options');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="checkbox"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.option-label').setAttribute('style', swatchStyle);
      });
    }
  }

  /**
   * click event To Remove current selections
   * @param {event} event Event Instance
   */
  onActiveFilterClick(event) {
    event.preventDefault();
    event.stopPropagation();
    let currentTarget = event.target;
    let URLString = null;
    if(currentTarget.dataset.type == 'tag_based'){
      const inputValue = currentTarget.dataset.remove;
      const inputElement  = document.querySelector(`input[data-tagslist][value="${inputValue}"]`);
      if(inputElement) inputElement.checked = false;

      let closestForm = document.getElementById('CollectionFiltersForm');
      if(!closestForm) return;
      URLString = this._finalQueryString(closestForm);
    }else if(currentTarget.dataset.type == 'sort_based'){
      const inputValue = currentTarget.dataset.remove;
      // const inputElement  = document.querySelector(`.drawer-filter-body [data-sortby] input[value="${inputValue}"]`);
      // if(inputElement) inputElement.checked = false;
      document.querySelector(`.drawer-filter-body [data-sortby] input[data-default-check]`).checked = true;
      document.querySelector('.drawer-filter-footer [name="sort_by"]').value = document.querySelector(`.drawer-filter-body [data-sortby] input[data-default-check]`).value;

      let closestForm = document.getElementById('CollectionFiltersForm');
      if(!closestForm) return;
      URLString = this._finalQueryString(closestForm);
    } else {
      if(event.target.closest('.filter-option-clear').classList.contains('filter-option-clear')){ 
        currentTarget = event.target.closest('.filter-option-clear');
        URLString = new URL(currentTarget.href).searchParams.toString();
      }
    }
    if(URLString != null)
      this.renderPage(URLString);
  }

   /**
   * Update Window URL as per active filters
   * @param {event} event Event Instance
   */
  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    // console.log('history change', searchParams)
    // this.renderPage(searchParams, null, false); // render-mm
  }

  renderPage(searchParams, event, updateURLHash = true) {
    document.getElementById('collection-product-grid').querySelector('#template-collection').classList.add('loading');
    const url = `${window.location.pathname}?${searchParams}`;

    this.renderGridFromFetch(url, 'filter');
    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderGridFromFetch(url, type) {
    if(!url) return;
    // console.log('fetching...');
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        this.renderProductGrid(html, type);
      });
  }

  renderProductGrid(html, type) {
    const innerHTML = new DOMParser().parseFromString(html, 'text/html');
    let paginationType = 'numbers';
    if(document.querySelector('[data-pagination]')){
      paginationType = document.querySelector('[data-pagination]').dataset.type || 'numbers';
    }
    
    if(type == 'filter' || type == 'sub_collection_filter'){
      const gridHTML = innerHTML.getElementById('collection-product-grid').innerHTML;
      const collTopText = innerHTML.getElementById('coll-top-text').innerHTML;
      const collBottomText = innerHTML.getElementById('coll-bottom-text').innerHTML;
      document.getElementById('coll-top-text').innerHTML = collTopText;
      document.getElementById('coll-bottom-text').innerHTML = collBottomText;
      document.getElementById('collection-product-grid').innerHTML = gridHTML;
      if(type == 'sub_collection_filter' && innerHTML.querySelector('[data-collectionBanner]') != null){
        let bannerHTML = innerHTML.querySelector('[data-collectionBanner]').innerHTML;
        document.querySelector('[data-collectionBanner]').innerHTML = bannerHTML;
      }
        this.updateTotalSelected()
    }else{
      if(paginationType == 'loadmore'){
        let productGrids = innerHTML.getElementById('template-collection').innerHTML;
        let loadMoreBtn =  innerHTML.getElementById('load-more');
        document.getElementById('template-collection').insertAdjacentHTML('beforeend', productGrids);
        if(loadMoreBtn && document.getElementById('load-more')){ 
          document.getElementById('load-more').parentNode.replaceChild(loadMoreBtn, document.getElementById('load-more')); 
        }
        else if(document.getElementById('load-more')){ document.getElementById('load-more').remove(); }
      }else{
        const gridHTML = innerHTML.getElementById('collection-product-grid').innerHTML;
        document.getElementById('collection-product-grid').innerHTML = gridHTML;
      }
    }

    const filterInnerHTML = innerHTML.getElementById('main-collection-filters').innerHTML;
    if(filterInnerHTML){ document.getElementById('main-collection-filters').innerHTML = filterInnerHTML;}

    const filterContainers = document.querySelectorAll('.filter__container');
    filterContainers.forEach(filter => {
      const tagList = filter.querySelectorAll('.filter__item');
      if(tagList.length <= 0){
        filter.classList.add('d-none');
        filter.style.display = 'none';
      }
    });

    if(innerHTML.querySelector('[data-totalProducts]')) {document.querySelector('[data-totalProducts]').innerHTML = innerHTML.querySelector('[data-totalProducts]').innerHTML;}
    if(innerHTML.querySelector('[data-collection-title]')){document.querySelector('[data-collection-title]').innerHTML = innerHTML.querySelector('[data-collection-title]').innerHTML}
    if(innerHTML.querySelector('[data-collectionmetafield]') && document.querySelector('[data-collectionmetafield]')){document.querySelector('[data-collectionmetafield]').innerHTML= innerHTML.querySelector('[data-collectionmetafield]').innerHTML}
    if(innerHTML.querySelector('[data-activeFilters]')) {document.querySelector('[data-activeFilters]').innerHTML = innerHTML.querySelector('[data-activeFilters]').innerHTML;}
    this.bindActiveFilterButtonEvents();
    // manageAppliedFilters of the current collection 
    this.appliedFiltersToggle();
    if(this.filterParent.classList.contains('filter-active')){
    document.querySelector('.collection-filters-close').click()
    }
    window.hulkappsReviews.init();
    window.customCodeForHulkReviewBadge();
  }

/** Applied filters Filters should get removed in filter on click */

  bindActiveFilterButtonEvents() {
    document.querySelectorAll('.filter-option-clear').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick, { once: true });
    });
  }

  updateTotalSelected(){
    let totalSelected =  document.querySelectorAll('collection-filters input:checked').length +1;
    if(document.querySelector('[data-subcollections]') == null)
      totalSelected = 1;
   // document.querySelector('[data-clearfilter]').innerText = `CLEAR (${totalSelected})`;
  }

  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  updateSortBy(event){
    let _this = event.currentTarget;
    let currentvalue;
    if(_this.name == 'custom_sort_by_mobile'){
      currentvalue = document.querySelector('[data-sortby] [name="custom_sort_by_mobile"]:checked').value;
    }
    if(_this.name == 'custom_sort_by_desktop'){
      currentvalue = document.querySelector('[data-sortby] [name="custom_sort_by_desktop"]:checked').value;
    }

    document.querySelector('[name="sort_by"]').value = currentvalue;
    document.querySelector('[name="sort_by"]').dispatchEvent(new Event('input', {
      bubbles: true,
      cancelable: true,
    }));
  }

  /**
   * 
   * @param {event} event 
   */
  paginateProductsBy(event){
    event.preventDefault();
    let _this = event.currentTarget;
    let currentValue;
    if(_this.name == 'paginateBy_mobile'){
      currentValue = document.querySelector('[data-custom-pagination] [name="paginateBy_mobile"]:checked').value;
    }
    if(_this.name == 'paginateBy_desktop'){
      currentValue = document.querySelector('[data-custom-pagination] [name="paginateBy_desktop"]:checked').value;
    }
    let requestData = {
      attributes: { 'products_per_page': currentValue }
    };

    fetch("/cart/update", {
    method: "POST",
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
    },
    body: JSON.stringify(requestData),
    }).then((data) =>{
      let closestForm = document.getElementById('CollectionFiltersForm');
      const params = new URLSearchParams(new FormData(closestForm));
      const searchParams = params.toString();
      const url = `${window.location.pathname}?${searchParams}`;
      if(_this.name == 'paginateBy_desktop'){
        this.renderGridFromFetch(url, 'pagination');
      }
    });
  }

  _manageSubCollections(event,applied=false){
    // console.log('manage collection');
    event.preventDefault();
    this.toggleSelectedCollection(event);
    let _this = event.currentTarget;
    let closestForm = document.getElementById('CollectionFiltersForm');
    const queryString = this._finalQueryString(closestForm);
    if(window.visualViewport.width <= 991){
      // console.log('mobile');
      if(applied == false) return;

      let collURL = window.location.pathname + '?' + queryString;

      if(this.querySelector('[data-subcollections] .collection-checkbox.active') != null)
      collURL = this.querySelector('[data-subcollections] .collection-checkbox.active').href + '?' + queryString;
      // console.log('col-url', collURL);
      this.renderGridFromFetch(collURL, 'sub_collection_filter');
      setTimeout(() => {
      history.pushState({}, '', collURL);
    }, 500); 
    
   }
    else
    {
    let collURL = _this.href + '?' + queryString;
    // console.log('col-url', collURL);
    this.renderGridFromFetch(collURL, 'sub_collection_filter');
    setTimeout(() => {
    history.pushState({}, '', collURL);
  }, 500); 
}
  }
  
  

  toggleSelectedCollection(event){
    
    let _this = event.currentTarget;
    if(!_this.classList.contains('collection-entry')) return;
    let currentSelected = document.querySelector('[data-subcollections] a.active');
    if(event.currentTarget == currentSelected) return;
    event.currentTarget.classList.add('active');
    if (currentSelected != undefined){
      currentSelected.classList.remove('active');
    }
  }

  _managePagination(event){
    event.preventDefault();

    window.scrollTo(0, 0);
    // This prevents the page from scrolling down to where it was previously.
    // if ('scrollRestoration' in history) {
    //    history.scrollRestoration = 'manual';
    // }
    // This is needed if the user scrolls down during page load and you want to make sure the page is scrolled to the top once it's fully loaded. This has Cross-browser support.
    // window.scrollTo(0,0);
    let _this = event.currentTarget;
    console.log('_this----',_this);
    this.renderGridFromFetch(_this.href, 'pagination');

    let paginationType = _this.closest('[data-paginationparent]').dataset.type;
    if(paginationType != 'loadmore'){
      setTimeout(() => {
        history.pushState({}, '', _this.href);
      }, 500);
    }
  }

  toggleFilterDrawer(event){
    event.stopImmediatePropagation();
    
    let button = event.currentTarget;
    if(button.id == 'filter-drawer'){
      if (this.filterParent.classList.contains('filter-active')) {
        this.filterParent.classList.remove('filter-active');
        document.body.style.overflowY = "auto";
        document.querySelector('body').classList.remove('scroll-fixed');
        document.body.addEventListener('touchmove', bodyTouchMove, true);
        if(this.openFilterDrawer){
          this.openFilterDrawer.setAttribute('aria-expanded', false);
          this.openFilterDrawer.removeAttribute('tabindex');
        }
      } else {
        this.filterParent.classList.add('filter-active');
        document.querySelector('body').classList.add('scroll-fixed');
        document.body.style.overflowY = "hidden";
        document.body.addEventListener('touchmove', bodyTouchMove, true);
        button.setAttribute('aria-expanded', true);
        button.setAttribute('tabindex', '-1');
      }
    }else{
      this.filterParent.classList.remove('filter-active');
      this.filterParent.classList.remove('sortby-drawer');
      document.body.style.overflowY = "auto";
      document.querySelector('body').classList.remove('scroll-fixed');
      document.body.addEventListener('touchmove', bodyTouchMove, true);
      if(this.openFilterDrawer){
        this.openFilterDrawer.setAttribute('aria-expanded', false);
        this.openFilterDrawer.removeAttribute('tabindex');
      }if(this.openSortbyDrawer){
        this.openSortbyDrawer.setAttribute('aria-expanded', false);
        this.openSortbyDrawer.removeAttribute('tabindex');
      }

      Utility.removeTrapFocus(this.filterParent);
      siteOverlay.prototype.hideOverlay();
    }
  }

  toggleFilterBlock(event) {
    event.preventDefault();
    const toggleFilterBtn = event.currentTarget;
    const filterContainer = toggleFilterBtn.parentNode;
    const isOpen = filterContainer.classList.contains('open');
    isOpen ? this.closeFilterBlock(toggleFilterBtn) : this.openFilterBlock(toggleFilterBtn);
  }

  openFilterBlock(toggleFilterBtn){
    let filterContainer = toggleFilterBtn.parentNode;
    toggleFilterBtn.setAttribute('aria-expanded', true);
    Utility.toggleElement(filterContainer, 'open');
    if(this.accordionType == 'single'){
      let siblingBlocks = filterContainer.parentNode.querySelectorAll('.filter__container');
      siblingBlocks.forEach(element => {
        if(element == filterContainer){ return; }
        element.classList.remove('open');
        element.querySelector('.filter__block').classList.remove('open');
        element.querySelector('.filter__toggle').setAttribute('aria-expanded', false);
      });
    }
    Utility.trapFocus(filterContainer);
  }

  closeFilterBlock(toggleFilterBtn){
    // console.log('closing');
    const filterContainer = toggleFilterBtn.parentNode;
    toggleFilterBtn.setAttribute('aria-expanded', false);
    Utility.toggleElement(filterContainer, 'close');
    Utility.removeTrapFocus(filterContainer);
  }

clearFilter(url){
  // console.log('clearing filter');
  let clearUrl = window.location.href.split('?')[0]+'?sort_by=manual';
  this.renderGridFromFetch(clearUrl, 'sub_collection_filter');
      setTimeout(() => {
      history.pushState({}, '', clearUrl);
    }, 500); 
}

  appliedFiltersToggle(){
    // console.log('setting active filter');
    // let totalSelectedFilters = document.querySelectorAll('collection-filters input:checked');
    // let activeFilterContainer = document.querySelector('[data-appliedfilters]');
    // if(activeFilterContainer) activeFilterContainer.innerHTML = '';
    
    // if(totalSelectedFilters.length) {
    //   totalSelectedFilters.forEach(appliedFilter =>{
    //     let currentSelected = appliedFilter.dataset.valued;
    //     let currentHandle = appliedFilter.value;
    //     let dataType = appliedFilter.dataset.type;
    //     if(currentSelected.toLowerCase() == 'featured' && totalSelectedFilters.length == 1) return;
    //     if(currentSelected.toLowerCase() != 'featured'){
    //         let activeFilterHtml = `<div class="active-filter__button text-uppercase text-white filter-option-clear" role="button" data-remove="${currentHandle}" data-type="${dataType}">${currentSelected}<span data-close class="icon-close"></span></div>`;   
    //         activeFilterContainer.innerHTML += activeFilterHtml;
    //       }
    //   })
    // }

    // if(activeFilterContainer && totalSelectedFilters.length >=2 ){
    //   activeFilterContainer.innerHTML += `<a href="${window.location.href.split('?')[0]+'?sort_by=manual'}" class="text-primary filter-option-clear clear-all" data-type="clear_all">Clear All<span data-close ></span></a>`;
    // }
    this.bindActiveFilterButtonEvents();
  }

}

customElements.define('collection-filters', CollectionFilters);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  
}

customElements.define('price-range', PriceRange);